import { z } from 'zod';

export const setNachversandEligibilityResDto = z.object({
  nachversandEligible: z.boolean(),
});
export type SetNachversandEligibilityResDto = z.infer<
  typeof setNachversandEligibilityResDto
>;
